export const SUPPLIER_ID_FIELD = 'supplierId';
export const DELIVERY_LIST_ITEMS_FIELD = 'deliveryListItems';
